// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/ava1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/ava2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/ava3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/edit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/open-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../assets/pin.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../assets/bulb.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 18px;
    gap: 5px;
    /*background: #FFF0DA;*/
    border-radius: 24px;
    position: relative;
}

.client--selected{
    background: #FFF0DA;
}

.client_head{
    display: flex;
    gap: 16px;
    width: 100%;
}

.client_avatar{
    width: 52px;
    height: 52px;
    border-radius: 100%;
    flex-shrink: 0;
    background-color: #0009;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.client_avatar_1{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.client_avatar_2{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.client_info{
    width: 100%;
}

.client_info_name{
    font-weight: 700;
    font-size: calc(16px * var(--fontScaler));
    line-height: 24px;
    color: #212633;
}


.client_info_dates{
    display: flex;
    align-items: center;
    gap: 6px;

    min-height: 24px;
}

.client_info_date{
    font-weight: 400;
    font-size: calc(12px * var(--fontScaler));
    line-height: 24px;
    color: #000;
    padding-right: 8px;
    border-right: 1px solid #ccc;
    white-space: nowrap;
    flex: 0 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 50%;
}

.client_info_date_1{

}

.client_info_date_2{
    border-right: none;
}

.client_info_edit{
    width: 12px;
    height: 12px;
    /*background-color: #0009;*/

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 10px;
    background-position: center;
    background-repeat: no-repeat;

    flex-shrink: 0;
}

.client_info_open{
    width: 12px;
    height: 12px;
    /*background-color: #0009;*/

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: 8px;
    background-position: center;
    background-repeat: no-repeat;
    transform: rotate(180deg);
    transition-duration: 200ms;

    flex-shrink: 0;
}   

.client_info_open--closed{
    transform: rotate(0deg);
}  

.client_more{
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding-bottom: 5px;
}

.client_more_item{
    padding: 3px 0px;
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: calc(12px * var(--fontScaler));
}

.client_more_item_icon{
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    /*background-color: #0009;*/

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-size: 18px;
    background-position: center;
    background-repeat: no-repeat;
}

.client_more_item_icon--bulb{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.client_more_item_text{

}

.client--closed{
    /*background-color: #0000;*/
}

.client--closed .client_more{
    display: none;
}

.client_loader_overlay{
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 24px;
    background-color: #fff9;
    display: flex;
    align-items: center;
    padding-left: 30px;
    top: 0;
    left: 0;

    .commonSpinner{
        font-size: 0;
    }
}

/* Responsive font sizing for ultra-narrow screens */
@media (max-width: 360px) {
    .client_info_date {
        font-size: calc(11px * var(--fontScaler));
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/client/Client.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,uBAAuB;;IAEvB,yDAAoD;IACpD,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,yDAAoD;AACxD;;AAEA;IACI,yDAAoD;AACxD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;;IAER,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;;AAEA;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;;IAE3B,yDAAoD;IACpD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;;IAE5B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;;IAE3B,yDAA0D;IAC1D,oBAAoB;IACpB,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;IACzB,0BAA0B;;IAE1B,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,2BAA2B;;IAE3B,yDAAmD;IACnD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,yDAAoD;AACxD;;AAEA;;AAEA;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,OAAO;;IAEP;QACI,YAAY;IAChB;AACJ;;AAEA,oDAAoD;AACpD;IACI;QACI,yCAAyC;IAC7C;AACJ","sourcesContent":[".client{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 12px 18px;\n    gap: 5px;\n    /*background: #FFF0DA;*/\n    border-radius: 24px;\n    position: relative;\n}\n\n.client--selected{\n    background: #FFF0DA;\n}\n\n.client_head{\n    display: flex;\n    gap: 16px;\n    width: 100%;\n}\n\n.client_avatar{\n    width: 52px;\n    height: 52px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-color: #0009;\n\n    background-image: url('../../../../assets/ava1.png');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.client_avatar_1{\n    background-image: url('../../../../assets/ava2.png');\n}\n\n.client_avatar_2{\n    background-image: url('../../../../assets/ava3.png');\n}\n\n.client_info{\n    width: 100%;\n}\n\n.client_info_name{\n    font-weight: 700;\n    font-size: calc(16px * var(--fontScaler));\n    line-height: 24px;\n    color: #212633;\n}\n\n\n.client_info_dates{\n    display: flex;\n    align-items: center;\n    gap: 6px;\n\n    min-height: 24px;\n}\n\n.client_info_date{\n    font-weight: 400;\n    font-size: calc(12px * var(--fontScaler));\n    line-height: 24px;\n    color: #000;\n    padding-right: 8px;\n    border-right: 1px solid #ccc;\n    white-space: nowrap;\n    flex: 0 1 auto;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 50%;\n}\n\n.client_info_date_1{\n\n}\n\n.client_info_date_2{\n    border-right: none;\n}\n\n.client_info_edit{\n    width: 12px;\n    height: 12px;\n    /*background-color: #0009;*/\n\n    background-image: url('../../../../assets/edit.svg');\n    background-size: 10px;\n    background-position: center;\n    background-repeat: no-repeat;\n\n    flex-shrink: 0;\n}\n\n.client_info_open{\n    width: 12px;\n    height: 12px;\n    /*background-color: #0009;*/\n\n    background-image: url('../../../../assets/open-arrow.svg');\n    background-size: 8px;\n    background-position: center;\n    background-repeat: no-repeat;\n    transform: rotate(180deg);\n    transition-duration: 200ms;\n\n    flex-shrink: 0;\n}   \n\n.client_info_open--closed{\n    transform: rotate(0deg);\n}  \n\n.client_more{\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    padding-bottom: 5px;\n}\n\n.client_more_item{\n    padding: 3px 0px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    font-size: calc(12px * var(--fontScaler));\n}\n\n.client_more_item_icon{\n    flex-shrink: 0;\n    width: 18px;\n    height: 18px;\n    /*background-color: #0009;*/\n\n    background-image: url('../../../../assets/pin.png');\n    background-size: 18px;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.client_more_item_icon--bulb{\n    background-image: url('../../../../assets/bulb.png');\n}\n\n.client_more_item_text{\n\n}\n\n.client--closed{\n    /*background-color: #0000;*/\n}\n\n.client--closed .client_more{\n    display: none;\n}\n\n.client_loader_overlay{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border-radius: 24px;\n    background-color: #fff9;\n    display: flex;\n    align-items: center;\n    padding-left: 30px;\n    top: 0;\n    left: 0;\n\n    .commonSpinner{\n        font-size: 0;\n    }\n}\n\n/* Responsive font sizing for ultra-narrow screens */\n@media (max-width: 360px) {\n    .client_info_date {\n        font-size: calc(11px * var(--fontScaler));\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
